import Vue from 'vue'

const DEFAULT_DURATION = 4000
const MAX_VISIBLE = 5

const state = Vue.observable({
  toasts: []
})

let counter = 0

function add (type, message, options = {}) {
  const id = ++counter
  const toast = {
    id,
    type,
    message: String(message ?? ''),
    description: options.description ? String(options.description) : '',
    duration: typeof options.duration === 'number' ? options.duration : DEFAULT_DURATION,
    persistent: !!options.persistent,
    action: options.action && typeof options.action.onClick === 'function'
      ? { label: String(options.action.label || 'Undo'), onClick: options.action.onClick }
      : null
  }

  state.toasts.push(toast)

  // Cap visible stack — remove the oldest if we're past the limit.
  while (state.toasts.length > MAX_VISIBLE) {
    state.toasts.shift()
  }

  return id
}

function dismiss (id) {
  const idx = state.toasts.findIndex((toast) => toast.id === id)
  if (idx !== -1) state.toasts.splice(idx, 1)
}

function clear () {
  state.toasts.splice(0, state.toasts.length)
}

const toast = {
  success: (message, options) => add('success', message, options),
  error: (message, options) => add('error', message, options),
  warning: (message, options) => add('warning', message, options),
  info: (message, options) => add('info', message, options),
  dismiss,
  clear,
  state
}

export default toast

export const ToastPlugin = {
  install (VueInstance) {
    VueInstance.prototype.$toast = toast
  }
}
